import { useState } from "react";
import { IonCard, IonIcon } from "@ionic/react";
import CardBackgroundImage from "../assets/graphics/QQ_HeroImage.png";
import { ReactComponent as PlayIcon } from "../assets/graphics/play_icon.svg";
import { person } from "ionicons/icons";
import { useQuestsStore } from "../stores/quests.store";
const QuoQuestCard: React.FC = () => {
  // eslint-disable-next-line
  const [showQuoQuest, setShowQuoQuest] = useState(false);
  const currentLevel = useQuestsStore(state =>
    state.levels.find(level => level.status === "unlocked")
  );
  return (
    <>
      <IonCard
        disabled // until it is working
        routerLink="/quest"
        className="p-2 button bg-gradient-main h-[250px] -mt-2 mb-2 mx-0 flex justify-between"
        onClick={() => setShowQuoQuest(true)}
      >
        <div className="flex flex-col pl-2 relative h-full">
          <div className="flex items-center">
            <IonIcon icon={person} className="text-white text-sm mt-4" />
            <p className="text-white px-2 mt-4">Single Player</p>
          </div>
          <p className="text-4xl text-white font-semibold">QuoQuest</p>
          <div className="inline-block">
            <span className="px-3 py-1 mt-1 inline-block bg-primary-80 rounded text-white text-base">
              Quest {currentLevel?.level}
            </span>
          </div>
          <p className="text-base text-white text-lg font-semibold max-w-[50%]">
            {currentLevel?.levelName}
          </p>
          <PlayIcon
            className="absolute left-2 bottom-2"
            color="primary"
            onClick={e => {
              e.stopPropagation();
              setShowQuoQuest(true);
            }}
          />
        </div>

        <div className="absolute -right-16 bottom-0">
          <img
            alt="hero-banner"
            src={CardBackgroundImage}
            className="h-[250px] mr-2"
          />
        </div>
      </IonCard>
    </>
  );
};

export default QuoQuestCard;
